import React, {
    useEffect, useState, useRef,
    useMemo,
    useCallback
} from "react"; import "../styles.css";

import 'components/customModal/modal.css'

import './settings.css'
import "../../views/styles.css";
import "bootstrap/dist/css/bootstrap.css";
// import ReactDragListView from 'react-drag-listview';
import "font-awesome/css/font-awesome.min.css";
import FadeIn from "react-fade-in";
import { useLoading, Rings } from "@agney/react-loading";
import { toast } from 'react-toastify';
const axios = require("axios");

function AddCardModal({handleClose}) {

    const getToken = () => {
        if (localStorage.getItem("keptLogged") == "true") {
            return localStorage.getItem("token") || null;
        }
        return sessionStorage.getItem("token") || null;
    };
    
   const AddCardApi = async (data) => {
    let  response = await axios({
            method: "post",
            url: process.env.REACT_APP_API_BASE_URL + `company/settings/addbank`,
            headers: {
                Authorization: "Bearer " + getToken(),
            },
            data: data,
        });
        return response.data;

    };
    


    useEffect(() => {
        // console.log("SSStripe",process.env.REACT_APP_STRIPE_PUB_KEY)
        // // const stripe = window.Stripe('pk_live_51LNskRGrSqg1SI86XFrPeOVJmhk03GmTXD1JoRiIIeYfejVWYeNWmVR2e9nfJe9Cl5jKBME65Vgr2uoj4t08CduD007XIzXJah');
        // const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUB_KEY);

        // // const stripe = loadStripe("pk_test_51MvcW9E9tpGbRpHpUB2u8R2bv7aDjiAaFhQJ5xcIYzKcgJILgQ8G2t4AsCTGk67VpqYmt2cv2OFlJ989ILkCJnk700LRlqpGpL");

        // const elements = stripe.elements();
        // const cardElement = elements.create('card');
        // cardElement.mount('#card-element');

        const cardButton = document.getElementById('card-button');

        const resultContainer = document.getElementById('card-result');



            cardButton.addEventListener('click', async (ev) => {
                let bank
                try{
                const cardholderName = document.getElementById('cardholder-name');

                const bankName = document.getElementById('bankName');
                const accNo = document.getElementById('accNo');
                const roNo = document.getElementById('roNo');
        


                 bank= {
                    bankName : bankName.value,
                    accountNo : Number(accNo.value),
                    routingNo :  Number (roNo.value),
                    accountHolderName : (cardholderName.value),
                }

            }catch(err){
                console.log(err)
                toast.error("Bank Account is not Valid")
            }
            // const {paymentMethod, error} = await stripe.createPaymentMethod({
            //     type: 'card',
            //     card: cardElement,
            //     billing_details: {
            //         name: cardholderName.value,
            //     },
            //     }
            // );

            // if (error) {
            //     // Display error.message in your UI.
            //     // resultContainer.textContent = error.message;
            //     console.log(error)
            //     toast.error(error?.message || "Card is not Valid")
            //     //handleClose()
            // } else {
                // You have successfully created a new PaymentMethod
               /// //resultContainer.textContent = "Created payment method: " + paymentMethod.id;
                //setShowCardModal(false)
                AddCardApi(bank).then((res) => {
                 
                    toast.success('Bank Account added successfully')
                    handleClose(bank)
                })
                .catch((err) => {
                    console.log(err)
                    toast.error(err?.response?.data?.raw?.message || "Bank Account is not Valid")
                  //  handleClose()
                });

            // }
            });

    },[])

    return ( <div
        className="modal fadeIn"
        style={{ display: "block", zIndex: 100 ,
        alignItems : 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.3)',
    
       }}
        role="dialog"
        id="kwModal"

    >
        {/* modal start */}

        <FadeIn>
            <div className="modal-dialog modal-dialog-centered kw-workflow-modal" role="document" style={{justifyContent: 'center', paddingTop:'4%'}}>
                <div className="cmodal modal-content" style={{maxWidth: "600px" , minHeight:'400px' ,
                    borderRadius: '12px' , borderWidth:0
            }}>
                                            <div className="m-header"> 
                        <span>{'Add Bank Account'}</span>
                        <span style={{ cursor: 'pointer' }} onClick={()=>handleClose()} >x</span>
                    </div>
                    <div className="card-cont">
                                <input id="cardholder-name" type="text" placeholder="Account Holder's Name"/>
                                <input class='card-inputs' id="bankName" type="text" placeholder="Bank Name"/>
                                <input class='card-inputs' id="accNo" type="text" placeholder="Account Number"/>

                                <input class='card-inputs' id="roNo" type="text" placeholder="Routing Number"/>


                       
                                <div className="m-footer">


                                <input
                                id="card-button"
                                    type="submit"
                                    name="Save"
                                    style={{ margin_top: "2v", cursor: "pointer" }}
                                    className="add lg_btn primary"
                                    value="Save"
                                />
                                </div>

                    </div>

                </div>

            </div>
        </FadeIn>
    </div>
       
    );
}
export default AddCardModal;
